import { memo, useCallback } from "react"

import { Form } from "react-bootstrap"

import NotificationNameCell from "./NotificationNameCell"
import NotificationApplicationUserData from "../../../api/Randoms/Notification/NotificationApplicationUserData"
import FormatPhone from "../../../formatters/FormatPhone"

interface NotificationApplicationUsersGridRowProps {
  user: NotificationApplicationUserData
  selectUser: (user: number[], checked: boolean) => void
}

function NotificationApplicationUsersGridRow({ user, selectUser }: NotificationApplicationUsersGridRowProps) {
  const { ApplicationUserID, UserName, FirstName, LastName, Email, Phone, selected } = user

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      selectUser([ApplicationUserID], e.target.checked)
    },
    [ApplicationUserID, selectUser]
  )

  const formattedPhone = Phone ? FormatPhone(Phone) : null

  return (
    <tr>
      <td className="justify-content-center align-middle">
        <Form.Check
          type="radio"
          name="random-notification-contact"
          id={`rau_${ApplicationUserID}`}
          className="abc-radio d-flex justify-content-center align-middle"
          value={ApplicationUserID}
          label=""
          checked={selected}
          disabled={!Email && !Phone}
          onChange={handleChange}
        />
      </td>
      <td>{UserName}</td>
      <td>
        <NotificationNameCell firstName={FirstName} lastName={LastName} />
      </td>
      <td>{Email}</td>
      <td>{formattedPhone}</td>
    </tr>
  )
}

export default memo(NotificationApplicationUsersGridRow)
